import { useEffect, useState, useCallback } from 'react';
import { getPerformance } from 'api/home';
import { TPerformanceResponse } from 'types/home';

const usePerformance = (weeks: number): [TPerformanceResponse['data'] | null, boolean, (weeks: number) => void] => {
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState<TPerformanceResponse['data'] | null>(null);

    const fetchData = useCallback(async (weeksParam: number) => {
        try {
            setLoading(true);
            const result = await getPerformance(weeksParam);
            if (!result.error) {
                setData(result.data.data || null);
            } else {
                setData(null);
            }
            setLoading(false);
        } catch (e) {
            console.error('Failed to fetch performance data:', e);
            setData(null);
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        fetchData(weeks);
    }, [weeks, fetchData]);

    return [data, loading, fetchData];
};

export default usePerformance;

